import type { FlatItem, DropdownValue } from '../../types';

export function normalizeParentSelection(
  selected: Set<DropdownValue>,
  itemsByDepthDesc: FlatItem[],
  descendantsByValue: Map<DropdownValue, DropdownValue[]>,
  selectableByValue: Map<DropdownValue, boolean>,
): Set<DropdownValue> {
  const normalized = new Set(selected);

  // Only group state is derived from descendants; values keep their explicit selection.
  for (const item of itemsByDepthDesc) {
    const selectableDescendants = descendantsByValue.get(item.value) ?? [];
    const isSelectable = selectableByValue.get(item.value) === true;

    if (!isSelectable) {
      normalized.delete(item.value);
      continue;
    }

    if (item.type === 'value' || selectableDescendants.length === 0) {
      continue;
    }

    const allDescendantsSelected = selectableDescendants.every((value) => normalized.has(value));

    if (!allDescendantsSelected) {
      normalized.delete(item.value);

      continue;
    }

    normalized.add(item.value);
  }

  return normalized;
}
